import { Artist, ArtistRole } from '@hooks/useAlbumInfo/types';
import { UnassociatedVideosResult } from '@hooks/useShowUnassociatedVideos/types';

export type UnassociatedVideosFormatted = {
  albumUri: string;
  albumCoverArtImage: string;
  trackName: string;
  artists: Artist[];
  isrc: string;
  uri: string;
  url: string;
  release: string;
  releaseDate: string;
};

export const formatUnassociatedVideosData = (
  unassociatedVideos: UnassociatedVideosResult['data']['unassociatedVideos'],
): UnassociatedVideosFormatted[] => {
  return unassociatedVideos
    .map(video => {
      if (video.videoTrackDetail) {
        const artists = video.videoTrackDetail.artists.filter(({ role }) =>
          [
            ArtistRole.MAIN_ARTIST,
            ArtistRole.FEATURED_ARTIST,
            ArtistRole.REMIXER,
          ].includes(role),
        );

        return {
          albumUri: video.videoTrackDetail.albumUri,
          albumCoverArtImage: video.videoTrackDetail.albumCoverArtImage,
          trackName: video.videoTrackDetail.name,
          artists,
          isrc: video.videoTrackDetail.isrc,
          uri: video.videoTrackDetail.uri,
          url: video.videoTrackDetail.url,
          release: video.videoTrackDetail.name,
          releaseDate: video.videoTrackDetail.originalAlbumReleaseDate,
        };
      }

      return null as any;
    })
    .filter(unassociatedVideo => !!unassociatedVideo);
};

export const getLoadingSkeletonData = (
  rowsAmount: number,
): UnassociatedVideosFormatted[] => {
  return Array(rowsAmount).fill({
    albumUri: '',
    albumCoverArtImage: '',
    trackName: '',
    artists: [] as Artist[],
    isrc: '',
    uri: '',
    url: '',
    release: '',
    releaseDate: '',
  });
};
